import React, { Component } from 'react';

class ItemTypeList extends Component {
    render() {
        const { itemtypes, onSelectItemType, onNewItemType } = this.props;

        return (
            <div className='admin_list'>
                <button onClick={onNewItemType}>Create New ItemType</button>

                {itemtypes.map((itemtype, index) => (
                    <div className='listElement' key={index} onClick={() => onSelectItemType(itemtype)}>
                        {itemtype.name}
                    </div>
                ))}

            </div>
        );
    }
}

export default ItemTypeList;
